// Action Types.
import {
  SET_CURRENT_STATUS_SUCCESS,
  SET_CURRENT_STATUS_ERROR,
  SET_CURRENT_STATUS_REQUEST,
} from '@redux/actions/actionTypes'

// Initial State.
const initialState = {
  status: null,
  loading: false,
}

const statusReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CURRENT_STATUS_SUCCESS:
      return { ...state, status: action.payload, loading: false }

    case SET_CURRENT_STATUS_REQUEST:
      return { ...state, loading: true }

    case SET_CURRENT_STATUS_ERROR:
      return { ...state, loading: false }

    default:
      return state
  }
}

export default statusReducer
